<template>
    <v-data-table
        :headers="realHeaders"
        :items="list"
        class="elevation-1"
        :items-per-page="-1"
        hide-default-footer
    >
        <template #item="row">
            <tr>
                <td
                    v-for="(header, i) in realHeaders.slice(0, -1)" :key="i"
                    :class="{'text--secondary': row.item.isHidden}"
                >
                    <template v-if="header.text === 'Название'">
                        <router-link :to="`/devices/view/${row.item.id}`">
                            {{ getCellValue(row.item, header) }}
                        </router-link>
                    </template>
                    <template v-else>
                        {{ getCellValue(row.item, header) }}
                    </template>
                </td>
                <td style="text-align: right;">
                    <v-btn
                        v-if="doesDeviceHasState(row.item)"
                        icon
                        color="primary"
                        @click="resetItemState(row.item)"
                        title="Сбросить состояние"
                    >
                        <v-icon>mdi-backup-restore</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="editItem(row.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="deleteItem(row.item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import {Device, doesDeviceHasState} from '@/models/Device'
import {TableHeader} from '@/components/common/TableHeader'
import {displayTime} from '@/utils/datetime'
import Browser from '@/mixins/Browser'

type Header = TableHeader<Device>

@Component({
    methods: {doesDeviceHasState}
})
export default class DeviceBrowser extends Browser<Device>
{
    defaultHeaders: Header[] = [
        {text: 'ID', value: 'id', align: 'start'},
        {text: 'Название', value: 'name'},
        {text: 'Группа', value: p => p.group?.name || 'Не задано'},
        {text: 'Тип', value: 'typeLabel'},
        {text: 'Тип подключения', value: 'linkTypeLabel'},
        {text: 'Код устройства', value: 'code'},
        {text: 'Последнее обновление', value: p => displayTime(p.lastPowerPacket?.processedAt)},
        {text: '', value: null},
    ]

    async fetchList() {
        this.list = await this.api.listDevices({
            ...this.filters,
            expand: ['group', 'lastPowerPacket', 'typeLabel', 'linkTypeLabel'],
        })
    }

    async resetItemState(device: Device) {
        if (device.id && await this.confirm('Вы уверены, что хотите сбросить состояние устройства?')) {
            const updatedItem = await this.api.resetDeviceState(device.id)
            this.list = this.list.map(r => r.id === updatedItem.id ? updatedItem : r)
        }
    }

    async deleteModel(device: Device): Promise<boolean> {
        return await this.api.deleteDevice(device.id)
    }
}
</script>
